<div class="signin-card-container">
  <emperor-card [type]="EmperorCardTypes.Outlined">
    <img
      class="logo"
      src="/assets/images/logomark_medium_orange_bkg.svg"
      alt="bold penguin logo"
    />

    <h2 class="subheader">Welcome</h2>

    <emperor-button
      class="emperor-ui-manually-set-size text-uppercase"
      (click)="gotoUnifiedAuth()"
      >Sign in</emperor-button
    >
    <div class="other-cta">
      <!-- Forgot password -->
      <a
        class="forgot-password"
        [href]="forgotPasswordUrl"
        (click)="onTagClick(forgotPasswordUrl)"
        >Forgot password?</a
      >
      <!-- Sign up CTA -->
      <div>
        Don't have an account?&nbsp;<a
          (click)="onTagClick(signupRoute)"
          [routerLink]="signupRoute"
          >Sign Up</a
        >
      </div>
    </div>

    <!-- Footer & Legal -->
    <app-footer></app-footer>
  </emperor-card>
</div>
